export default {
  computed: {
    basket: {
      get() {
        return this.$basket.basket
      },
      set(value) {
        this.$basket.basket = value
      }
    },
    hasItems: {
      get() {
        return !!this.basket.items && this.basket.items.length > 0
      }
    },
    basketItems: {
      get() {
        return this.hasItems ? this.basket.items : []
      }
    },
    chargeItems: {
      get() {
        return this.basketItems.filter(i => i.itemType === 'charge')
      }
    },
    eCardItems: {
      get() {
        return this.basketItems.filter(i => i.itemType === 'ecard')
      }
    },
    rateItems: {
      get() {
        return this.basketItems.filter(i => i.itemType === 'rate')
      }
    },
    reservationItems: {
      get() {
        return this.basketItems.filter(i => i.itemType === 'reservation')
      }
    },
    deliveryTypes: {
      get() {
        return this.basket.availableDeliveryTypes ? this.basket.availableDeliveryTypes : []
      }
    },
    availableCredit: {
      get() {
        return this.basket.availableCredit !== undefined ? this.basket.availableCredit : 0
      }
    },
    selectedDelivery: {
      get() {
        return this.basket.selectedDelivery ? this.basket.selectedDelivery : null
      }
    },
    deliveryPrice: {
      get() {
        var price = 0
        this.deliveryTypes.forEach((type) => {
          price += (type.typeId === this.basket.selectedDeliveryType) ? type.price : 0
        })
        return price
      }
    },
    // coupons() {
    // if (this.basket.coupons === null || this.basket.coupons === undefined) {
    //   this.basket.coupons = []
    // }
    //   return this.basket.coupons
    // },
    hasCoupons: {
      get() {
        return this.basket.coupons !== undefined && this.basket.coupons.length !== 0
      }
    },
    totalDiscount: {
      get() {
        return this.basket.totalDiscount !== undefined ? this.basket.totalDiscount : 0
      }
    },
    totalPrice: {
      get() {
        return this.basket.totalPrice !== undefined ? this.basket.totalPrice : 0
      }
    },
    totalCredit: {
      get() {
        return this.basket.totalCredit !== undefined ? this.basket.totalCredit : 0
      }
    },
    fullTotalPrice: {
      get() {
        return this.basket.fullTotalPrice ? this.basket.fullTotalPrice : 0
      }
    },
    totalVat: {
      get() {
        let total = 0
        const items = this.basketItems
        for (let i = 0; i < items.length; i++) {
          total += items[i].vat
        }
        return total
      }
    },
    nettoFullTotalPrice: {
      get() {
        return this.fullTotalPrice - this.totalVat
      }
    },
    totalPriceToPay: {
      get() {
        return this.basket.totalPriceToPay ? this.basket.totalPriceToPay : 0
      }
    },
    finalPrice: {
      get() {
        return this.totalPrice - this.totalCredit + this.deliveryPrice - this.totalDiscount
      }
    },
    necessaryCredit: {
      get() {
        return this.basket.necessaryCreditToCharge
      }
    },
    basketCredit: {
      get() {
        let c = 0
        if (this.hasItems) {
          this.basketItems.filter(item => item.itemType === 'charge').forEach(item => {
            c += item.amount
          })
        }
        return c
      }
    },
    shouldPay: {
      get() {
        return this.totalPriceToPay > 0
      }
    },
    allCredit: {
      get() {
        return this.fullTotalPrice === this.totalCredit && this.totalCredit !== 0
      }
    },
    cardsTotalCredit: {
      get() {
        return this.basket.cardsTotalCredit ? this.basket.cardsTotalCredit : []
      }
    }
  },
  methods: {
    eticketTotal(card) {
      let total = 0
      const items = this.basketItems
      for (let i = 0; i < items.length; i++) {
        if (items[i].itemType === 'ecard' && items[i].itemDesc === card.cardNo) {
          total += items[i].total
        }
      }
      return total
    },
    basketItem(item) {
      const bi = this.basketItems.find(i => i.goodsItemItemId === item.itemId)
      return bi ? bi : {}
    },
    volumeWithItem(item) {
      const items = this.basketItems
      for (let i = 0; i < items.length; i++) {
        if (items[i].goodsItemItemId === item.itemId) {
          return items[i].volume
        }
      }
      return 0
    },
    deliveryWith(value) {
      return this.deliveryTypes.find(delivery => delivery.typeId === value)
    },
    emptyBasket() {
      this.fetchBasket(null)
    },
    refreshBasket() {
      this.fetchBasket({ basket: this.basket }, null, true)
    },
    chargeCard(card, amount) {
      var myData = {
        charges: [{
          card: card.cardId,
          amount: amount
        }],
        basket: this.basket
      }
      this.fetchBasket(myData, 'charges')
    },
    rechargeCard(cardId) {
      var myData = {
        basket: this.basket
      }
      this.fetchBasket(myData, 'refill-charges' + (cardId ? ('/' + cardId) : ''))
    },
    putECard(card) {
      var myData = {
        ecards: [{
          cardId: card.cardId
        }],
        basket: this.basket
      }
      this.fetchBasket(myData, 'ecards')
    },
    putGoods(item, creditCardId = null) {
      var myData = {
        goods: [{
          itemId: item.itemId,
          volume: item.volume > 0 ? item.volume : 1,
          creditCardId: creditCardId
        }],
        basket: this.basket
      }
      this.fetchBasket(myData, 'goods')
    },
    putCoupons(coupons) {
      var myData = {
        coupons: coupons,
        basket: this.basket
      }
      this.fetchBasket(myData, 'coupons')
    },
    putReservations(reservations) {
      var myData = {
        reservations: reservations,
        basket: this.basket
      }
      this.fetchBasket(myData, 'reservations')
    },
    putRates(rates) {
      var myData = {
        rates: rates,
        basket: this.basket
      }
      this.fetchBasket(myData, 'rates')
    },
    fetchBasket(value = null, action = null, refresh = null) {
      const path = 'baskets' + (value && value.basket && value.basket.basketId ? '/' + value.basket.basketId : '') + (action ? '/' + action : '')
      return this.$oauth2.$fetch(path, value && (action || refresh) ? {
        method: (action || refresh) ? 'PUT' : 'GET',
        body: JSON.stringify(refresh ? value.basket : value)
      } : undefined).then(data => {
        this.basket = data
        this.$oauth2.storage.setValue('chip-bas-id', data.basketId, this.institutionId, this.customerId)
      }).catch(error => {
        this.$oauth2.storage.removeValue('chip-bas-id', this.institutionId, this.customerId)
        console.log(error)
      })
    },
    // getStoredBasket() {
    //   const basketId = this.$oauth2.storage.hasValue('chip-bas-id') ? this.$oauth2.storage.getValue('chip-bas-id') : null
    //   const path = 'baskets' + (basketId ? '/' + basketId : '')
    //   return this.$oauth2.$fetch(path).then(data => {
    //     this.basket = data
    //   }).catch(console.log)
    // },
    removeItem(item, isCoupon = false) {
      const path = 'baskets/' + this.basket.basketId + (isCoupon ? '/coupons/' + item.couponId : '/items/' + item.itemId)
      return this.$oauth2.$fetch(path, { method: 'DELETE' }).then(data => {
        this.basket = data
        if (!this.hasItems && this.$route.meta.checkBasket) {
          const name = !this.isRegistered ? 'eshop' : 'reservations'
          this.$router.push({
            name: name
          }).catch(console.log)
        }
      }).catch(console.log)
    },
    addItem(item, creditCardId = null) {
      this.putGoods(item, item.canUseCredit == true ? creditCardId : null)
    },
    decrementItem(item) {
      item.volume = item.volume - 1
      if (item.volume <= 0) {
        this.removeItem(item)
      } else {
        this.refreshBasket()
      }
    },
    incrementItem(item) {
      item.volume = item.volume + 1
      this.refreshBasket()
    },
    lastItem() {
      return this.hasItems ? this.basket.items[this.basket.items.length - 1] : null

    },
    chargedCredit(card) {
      var charged = 0
      this.chargeItems.filter(i => card === undefined || card.cardId === i.chargeItemItemId).forEach(i => {
        charged += i.price
      })
      return charged
    }
  }
}
